<script setup>
import SaveTaskTimeAction from "@frontJs/components/actions/projectManagement/tasks/SaveTaskTimeAction.vue";
import ToggleTaskTimeIsFreeAction from "@frontJs/components/actions/projectManagement/tasks/ToggleTaskTimeIsFreeAction.vue";
import ToggleTaskTimeValidatedAtAction from "@frontJs/components/actions/projectManagement/tasks/ToggleTaskTimeValidatedAtAction.vue";
import { CheckIcon, PencilIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import CurrencyEuroIcon from "@js/components/icons/CurrencyEuroIcon.vue";
import CurrencyEuroOffIcon from "@js/components/icons/CurrencyEuroOffIcon.vue";
import { toast } from "vue3-toastify";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
  task: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: true,
  },
  toValidate: {
    type: Boolean,
    default: null,
    required: false,
  },
  validated: {
    type: Boolean,
    default: null,
    required: false,
  },
});

function saveTaskTimeCallback() {
  toast.clearAll();
  toast.success(t("all.toast.successfullyUpdated"), { position: "top-right" });
  props.callback();
}
</script>

<template>
  <div class="flex items-center justify-start gap-2 p-4">
    <ToggleTaskTimeValidatedAtAction
      v-if="props.toValidate || props.validated"
      :task-time="props.row.original"
      :callback="saveTaskTimeCallback"
    >
      <template #button="{ action }">
        <ActionButton
          size="small"
          type="secondary"
          class="size-8"
          :callback="() => action()"
          :title="
            props.row.original.validatedAt
              ? t('all.button.invalidate')
              : t('all.button.validate')
          "
        >
          <XMarkIcon
            v-if="props.row.original.validatedAt"
            class="size-5 flex-shrink-0"
          />
          <CheckIcon v-else class="size-5 flex-shrink-0" />
        </ActionButton>
      </template>
    </ToggleTaskTimeValidatedAtAction>

    <ToggleTaskTimeIsFreeAction
      :task-time="props.row.original"
      :callback="saveTaskTimeCallback"
    >
      <template #button="{ action }">
        <ActionButton
          size="small"
          type="secondary"
          class="size-8"
          :callback="() => action()"
          :title="
            props.row.original.isFree
              ? t('all.button.haveToPay')
              : t('all.button.isFree')
          "
        >
          <CurrencyEuroOffIcon
            v-if="props.row.original.isFree"
            class="size-5 flex-shrink-0"
          />
          <CurrencyEuroIcon v-else class="size-5 flex-shrink-0" />
        </ActionButton>
      </template>
    </ToggleTaskTimeIsFreeAction>

    <SaveTaskTimeAction
      :task="props.task"
      :task-time="props.row.original"
      :callback="saveTaskTimeCallback"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          :callback="() => setIsOpen(true)"
          class="size-8"
          :title="t('all.button.edit')"
        >
          <PencilIcon class="size-5 flex-shrink-0" />
        </ActionButton>
      </template>
    </SaveTaskTimeAction>
  </div>
</template>
